import { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
	Box,
	Card,
	CardContent,
	TextField,
	Button,
	Typography,
	Alert,
	Link,
} from '@mui/material'
import { supabase } from '../lib/supabase'

export function ForgotPasswordPage() {
	const [email, setEmail] = useState('')
	const [error, setError] = useState(null)
	const [success, setSuccess] = useState(false)
	const [isSubmitting, setIsSubmitting] = useState(false)

	const handleSubmit = async (e) => {
		e.preventDefault()
		setError(null)
		setIsSubmitting(true)

		try {
			const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
				redirectTo: `${window.location.origin}/reset-password`,
			})

			if (resetError) {
				setError(resetError.message)
				setIsSubmitting(false)
				return
			}

			setSuccess(true)
		} catch (err) {
			setError(err.message || 'An error occurred')
		} finally {
			setIsSubmitting(false)
		}
	}

	return (
		<Box
			mt={20}
			paddingTop='5rem'
			display="flex"
			justifyContent="center"
			alignItems="center"
			minHeight="60vh"
			maxWidth="sm"
			margin='auto'
		>
			<Card
				elevation={4}
				sx={{
					borderRadius: 3,
					px: 6,
					py: 8,
					width: '100%',
					textAlign: 'center',
				}}
			>
				<CardContent>
					<Typography variant="h4" fontWeight="bold" gutterBottom>
						Reset Password
					</Typography>
					<Typography variant="body1" color="text.secondary" mb={4}>
						Enter your email and we&apos;ll send you a link to reset your password.
					</Typography>
					{success ? (
						<>
							<Alert severity="success" sx={{ mt: 2, textAlign: 'left' }}>
								If an account exists with that email, you will receive a password reset link shortly.
							</Alert>
							<Box sx={{ mt: 3, textAlign: 'center' }}>
								<Link component={RouterLink} to="/auth" underline="hover">
									Back to sign in
								</Link>
							</Box>
						</>
					) : (
						<Box component="form" onSubmit={handleSubmit} sx={{ textAlign: 'left' }}>
							<TextField
								fullWidth
								id="email"
								label="Email"
								type="email"
								placeholder="your@email.com"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								required
								autoComplete="email"
								margin="normal"
							/>
							{error && (
								<Alert severity="error" sx={{ mt: 2 }}>
									{error}
								</Alert>
							)}
							<Button
								type="submit"
								variant="contained"
								fullWidth
								disabled={isSubmitting}
								sx={{ mt: 3, py: 1.5 }}
							>
								{isSubmitting ? 'Sending...' : 'Send Reset Link'}
							</Button>
							<Box sx={{ mt: 2, textAlign: 'center' }}>
								<Typography variant="body2" color="text.secondary">
									<Link component={RouterLink} to="/auth" underline="hover">
										Back to sign in
									</Link>
								</Typography>
							</Box>
						</Box>
					)}
				</CardContent>
			</Card>
		</Box>
	)
}
